import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ScopeMode } from '@shared/lib/scope'

import { useCsRoutes } from '@shared/api'

import { useProgressReportStore } from '../model/store'

interface ProgressReportsListApiOptions {
  onStart?: () => void
  onSuccess?: (reports: ProgressReport[]) => void
  onError?: (err: any) => void
  onFinish?: () => void
}

interface ProgressReportsListApiReturn {
  getProgressReportList: (disciplineId: number, mode: ScopeMode) => Promise<void>
}

export const useProgressReportsListApi = (options?: ProgressReportsListApiOptions): ProgressReportsListApiReturn => {
  const getProgressReportList = async (disciplineId: number, mode: ScopeMode): Promise<void> => {
    const { $axios } = useNuxtApp()

    const progressReportStore = useProgressReportStore()

    const url = useCsRoutes('disciplines.progress-reports', {
      '[discipline_id]': disciplineId,
    })

    if(!url) {
      console.error('No progress reports route found')
      return
    }

    options?.onStart?.()
    const requestId = progressReportStore.beginList(disciplineId, mode)

    try {
      const { data } = await $axios.get(url)
      const reports: ProgressReport[] = data.data || []

      progressReportStore.settleList(disciplineId, requestId, reports)
      options?.onSuccess?.(reports)
    } catch (err: any) {
      console.error(err)
      progressReportStore.failList(disciplineId, requestId)
      options?.onError?.(err)
    } finally {
      options?.onFinish?.()
    }
  }

  return {
    getProgressReportList,
  }
}
